export default "__VITE_ASSET__Df$SyoS3__"